module.exports = __webpack_public_path__ + "assets/img/7ff2-in.svg";